import Animation from './animation'
import * as d3 from 'd3-selection'

class BasicAnimation extends Animation {

  match () {
    // This animation runs last
    return true
  }

  animate (serie, entering, selection, merged, exiting) {
    let prev = this.previousPies
      , styles = this.styles

    if (merged.node()) {
      // Slice labels are hidden for most animations
      // When we have a basic animation, don't hide the slice labels.
      // See Impact #43702
      d3.select(merged.node().parentNode.parentNode)
        .selectAll('g.pie-slice-labels-container')
        .style('opacity', 1)
    }

    merged.call(this.fadeIn, this.styles)
          .call(this.tweenPath, this.arcTweener)
  }

}

export default BasicAnimation
